
export { IconContext } from "/codebuild/output/src2598429418/src/node_modules/react-icons/lib/esm/iconContext.js"